import { useGetDatabase } from '../db'
import { useListVals } from 'react-firebase-hooks/database'
import { ref } from 'firebase/database'

export const useList = (path, options) => {
  const db = useGetDatabase()

  return useListVals(ref(db, path), options)
}
